import { render, staticRenderFns } from "./ProfitAndLoss.vue?vue&type=template&id=7c26ca48&scoped=true&lang=pug&"
import script from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLoss.vue?vue&type=style&index=0&id=7c26ca48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c26ca48",
  null
  
)

/* custom blocks */
import block0 from "./ProfitAndLoss.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VDivider,VIcon,VLayout,VProgressCircular,VRow,VSpacer})
